/**
 * Created by slava on 24.03.17.
 */

const RateWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.RATE_WINDOW);

        const styles = cleverapps.styles.RateWindow;

        const content = this.createContent();

        this._super({
            content,
            title: Messages.get("RateWindow.title"),
            name: "ratewindow",
            styles: cleverapps.styles.RateWindow,
            button: {
                width: styles.button.width,
                height: styles.button.height,

                text: Messages.get("RateUs"),

                onPressed: function () {
                    this.openRateUrl();
                    this.close();
                }.bind(this)
            },
            contentPadding: styles.contentPadding
        });

        this.addPerson();
    },

    getPerson: function () {
        return "hero";
    },

    addPerson: function () {
        const stars = new cc.Sprite(bundles.rate_window.frames.stars_png);
        this.window.addChild(stars);
        stars.setAlignment(cleverapps.styles.RateWindow.stars);
        stars.setLocalZOrder(20);
    },

    createContent: function () {
        const styles = cleverapps.styles.RateWindow;

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize(styles.width, styles.height);

        const text = cleverapps.UI.generateOnlyText(Messages.get("RateWindow.text", {
            gameTitle: Messages.get(cleverapps.config.name)
        }), cleverapps.styles.FONTS.RATE_WINDOW_TEXT || cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width, 0);
        text.fitTo(undefined, styles.text.height);
        content.addChild(text);
        text.setAlignment(styles.text);

        if (bundles.rate_window.frames.text_bg_png) {
            const bgRect = cc.rectAddPadding(cc.rect(0, 0, content.width, styles.text.height), cc.padding(styles.text.padding));

            const textBg = cleverapps.UI.createScale9Sprite(bundles.rate_window.frames.text_bg_png);
            textBg.setContentSize(bgRect.width, bgRect.height);
            content.addChild(textBg, -1);
            textBg.setAlignment(text.x, text.y);
        }

        return content;
    },

    openRateUrl: function () {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.RATE_SEND);

        if (connector.platform.canReview()) {
            connector.platform.requestReviewCallback((code) => {
                if (connector.platform.oneOf(connector.ANDROID, connector.MICROSOFT)) {
                    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.NATIVE_REVIEW + code);
                } else {
                    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.SOCIAL_REVIEW + code);
                }
            });

            return;
        }

        const rateUrl = connector.platform.getRateUrl();
        if (rateUrl) {
            connector.platform.openUrl(rateUrl);
        }
    },

    onClose: function () {
        cleverapps.dataLoader.save(DataLoader.TYPES.RATED, true, { raw: true });
    },

    listBundles: function () {
        return ["rate_window"];
    }
});

RateWindow.CanRate = function () {
    const rated = cleverapps.dataLoader.load(DataLoader.TYPES.RATED, { raw: true });
    if (cleverapps.flags.norest || !levels.user.checkAvailable(cleverapps.config.availables.RATE_WINDOW) || rated) {
        return false;
    }

    return connector.platform.canReview() || connector.platform.getRateUrl();
};

const RateWindowAction = function (f) {
    if (this.game.outcome === GameBase.OUTCOME_VICTORY && RateWindow.CanRate()) {
        new RateWindow();
        cleverapps.focusManager.onceNoWindowsListener = f;
    } else {
        f();
    }
};

cleverapps.styles.RateWindow = {
    width: 650,
    height: 300,

    stars: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 240 }
    },

    text: {
        width: 610,
        height: 200,

        x: { align: "center" },
        y: { align: "center" },

        padding: {
            x: 10,
            y: 20
        }
    },

    button: {
        width: 300,
        height: 100
    },

    contentPadding: {
        top: 100
    }
};
